export default __webpack_public_path__ + "static/media/db_grey.cef7644e.svg";